import { useEffect, useState } from "react";

export const PHASES = [
  { label: "Breathe in", secs: 4, scale: 1 },
  { label: "Hold", secs: 4, scale: 1 },
  { label: "Breathe out", secs: 4, scale: 0.6 },
  { label: "Hold", secs: 4, scale: 0.6 },
];

export function useBoxBreathing() {
  const [phase, setPhase] = useState(0);
  const [count, setCount] = useState(PHASES[0].secs);

  useEffect(() => {
    const t = setInterval(() => {
      setCount((c) => {
        if (c > 1) return c - 1;
        setPhase((p) => (p + 1) % PHASES.length);
        return PHASES[(phase + 1) % PHASES.length].secs;
      });
    }, 1000);
    return () => clearInterval(t);
  }, [phase]);

  return { phase: PHASES[phase], count };
}
